export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Caută adresa de livrare',
      },
      placeholder: 'Introdu adresa pentru a găsi cea mai apropiată locație',
    },
  },
  toasts: {
    failed_to_load_stores: 'Nu s-au putut încărca restaurantele, reîmprospătează pagina',
  },
  errors: {
    no_delivery_companies: 'Livrarea nu este disponibilă pentru această adresă',
    delivery_not_available: 'Din păcate, nu oferim livrare în acest moment',
    location_unavailable: 'Nu am putut accesa locația ta, activează permisiunile sau introdu adresa manual',
    location_lookup_failed: 'Nu am putut găsi adresa ta, încearcă din nou',
    address_suggestions_unavailable: 'Sugestiile de adrese nu au putut fi încărcate.',
  },
  buttons: {
    use_current_location: 'Folosește locația mea curentă',
    locating: 'Se determină locația ta…',
    retry: 'Încearcă din nou',
  },
};
